import type { ButtonProps } from '@mui/material/Button';
import SubmitBase from '../base/Submit';
import useFormContext from './useFormContext';

interface SubmitProps extends ButtonProps {
  submitting?: boolean;
}

function Submit(props: SubmitProps) {
  const { submitting = false, ...restProps } = props;
  const { formState } = useFormContext() as {
    formState: { isSubmitting: boolean };
  };
  return <SubmitBase submitting={formState.isSubmitting || submitting} {...restProps} />;
}

Submit.displayName = 'Submit(Generic)';
export default Submit;
